<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-7">
          <money-box-new-form @codeChange="codeChange">
          </money-box-new-form>
        </div>
        <div class="col-md-4">
          <card style="width: max-content;">
            <span style="margin-bottom: 10px;display: inline-block;">QR Kod Alanı</span>
            <qrcode-vue v-if="code.length" :value="code" :size="150" level="H" />
            <qrcode-vue v-if="code.length" ref="qrDownload" :value="code" :size="1000" level="H" style="display: none;" />
            <div v-if="code.length" style="margin-top: 10px;">
              <a-button size="small" @click="downloadQr">QR Kodu İndir</a-button>
            </div>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import QrcodeVue from 'qrcode.vue'
  import MoneyBoxNewForm from './MoneyBox/MoneyBoxNewForm.vue'

  export default {
    components: {
      MoneyBoxNewForm,
      QrcodeVue
    },
    data(){
      return {
        code: ''
      }
    },
    methods:{
      codeChange(code){
        const self = this;
        self.code = 'mbapp01-'+code
      },
      downloadQr(){
        const canvas = this.$refs.qrDownload.$el.querySelector('canvas')
        if (!canvas) return
        const link = document.createElement('a')
        link.download = 'kumbara-' + this.code.replace('mbapp01-', '') + '-qr.png'
        link.href = canvas.toDataURL('image/png')
        link.click()
      }
    }
  }

</script>
<style>

</style>
